"use strict";

define('controller/template/submission',['underscore', '../base'], function (_, RegionController) {
  var TemplateSubmissionController = RegionController.extend({
    authorities: ['PERM_EFORMS_MODIFY_TEMPLATE'],
    onStart: function onStart() {
      var app = this.app;
      this.state.trigger('page:loaded');
      _.defer(function () {
        app.navigate('template/list/Submission', {
          trigger: true,
          replace: true
        });
      });
    }
  });
  return TemplateSubmissionController;
});

